import styled from 'styled-components';
import bg from 'images/bg-404.png';
import bgDots from 'images/bg-dots.png';
import bgArc1 from 'images/bg-arc-1.png';
import bgArc2 from 'images/bg-arc-2.png';
import { colors } from 'themes/colors';

export const Wrapper = styled.div`
  position: fixed;
  height: 100%;
  width: 100%;
  background: #202530 url(${bg}) bottom center repeat-x;
  background-size: contain;
  display: flex;
  padding: 25px;
  justify-content: center;
  align-items: center;
  text-align: center;
  font-family: 'Lato';
  font-size: 10px;
  @media (max-width: 1200px) {
    font-size: 9px;
  }
  @media (max-width: 600px) {
    font-size: 6px;
  }

  img {
    max-width: 450px;
    margin: 10px auto;
    z-index: 2;
    position: relative;
    width: 100%;
  }

  h4 {
    font-size: 3em;
    font-weight: 700;
    text-transform: uppercase;
    color: #fff;
    margin: 20px 0;
    z-index: 1;
    position: relative;
  }
  > section {
    min-height: 525px;
    width: 100%;
    background: url(${bgDots}) center repeat-x;
    padding-top: 100px;
    position: relative;
    @media (max-width: 600px) {
      padding: 50px 0;
    }
    &:before {
      position: absolute;
      content: '';
      bottom: 0;
      left: 50px;
      width: 313px;
      height: 372px;
      background: url(${bgArc1}) center;
      background-size: contain;
    }
    &:after {
      position: absolute;
      content: '';
      top: 0;
      right: 50px;
      width: 313px;
      height: 372px;
      background: url(${bgArc2}) center;
      background-size: contain;
    }
  }
  a {
    background: ${colors.primary};
    font-size: 16px;
    text-transform: uppercase;
    max-width: 350px;
    padding: 15px 25px;
    display: block;
    color: #fff;
    border-radius: 5px;
    margin: auto;
    z-index: 1;
    position: relative;
  }
`;



// WEBPACK FOOTER //
// ./src/containers/NotFoundPage/styles.js